// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-title-column{display:contents;color:rgba(9,36,51,.6)}@media (max-width:991px){.table-title-column{display:none}}.table-title-column__cell{padding:16px 16px 16px 0}.table-title-column__cell:not(:last-child){border-bottom:1px solid rgba(9,36,51,.1)}.table-title-column__cell :last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
